export const JWT_KEY = 'check-mate-access-token';
export const ADMIN = 'admin';
export const AGENT_TYPE = 'agentType';
